
//const languageDictionary = require(process.env.REACT_APP_PATH_LANGUAGE)
const languageDictionary = process.env.REACT_APP_REGION === 'latam' ? require('../languages/latam.json') : require('../languages/br.json');

export default languageDictionary;